var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isIndex?'paddingBottom':'',attrs:{"id":"course-class"}},[(_vm.activityShow)?_c('top-activity'):_vm._e(),_c('Header'),_c('content',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }